<template>
    <span>
        <!-- Menú lateral que aparece sólo cuando drawer == true, siendo ésto posible sólo en ventanas sm y menores: -->
        <v-navigation-drawer
            v-if="isAuthenticated"
            app
            v-model="drawer"
            class="grey lighten-5"
            disable-resize-watcher
        >
            <v-list dense class="pt-0">

                <v-list-item>
                    <v-list-item-action>
                        <v-icon color="light-blue darken-4">mdi-account</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                         <v-list-item-title>{{ userName }}</v-list-item-title>
                    </v-list-item-content>

                </v-list-item>

                <v-divider></v-divider>

                <!-- Administradores: -->
                <v-list-item v-if="userType === 1" @click="onEspecies">
                    <v-list-item-action>
                        <v-icon color="light-blue darken-4">mdi-dog-side</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Catálogo de especies</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Administradores: -->
                <v-list-item v-if="userType === 1" @click="onVeterinarias">
                    <v-list-item-action>
                        <v-icon color="light-blue darken-4">mdi-hospital-building</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Clínicas veterinarias</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Administradores: -->
                <v-list-item v-if="userType === 1" @click="onAdministradores">
                    <v-list-item-action>
                        <v-icon color="light-blue darken-4">mdi-account-key</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Administradores</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item v-if="userType === 1" @click="onMascotas">
                    <v-list-item-action>
                        <v-icon color="light-blue darken-4">mdi-dog</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Mascotas</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item v-if="userType === 1" @click="onClientesPublicidad">
                    <v-list-item-action>
                        <v-icon color="light-blue darken-4">mdi-domain</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Clientes de Publicidad</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="userType === 1" @click="onPublicidad">
                    <v-list-item-action>
                        <v-icon color="light-blue darken-4">mdi-advertisements</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Campañas de Publicidad</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item @click="onLogout">
                    <v-list-item-action>
                        <v-icon color="light-blue darken-4">mdi-exit-to-app</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Salir</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <!-- Termina menú lateral para dispositivos con ventanas sm y menores-->

        <v-app-bar
            v-if="isAuthenticated"
            color="grey lighten-5"
            elevation="2"
            fixed
            app
            clipped-left
            prominent
        >
            <v-app-bar-nav-icon
                v-if="isAuthenticated"
                class="hidden-md-and-up"
                @click="drawer = !drawer"
            ></v-app-bar-nav-icon>

            <router-link to="/">
                <img height="120" :src="logo1" @click="onHome" class="logo-hover"/>
            </router-link>

            <!-- Administradores: -->
            <v-toolbar-title v-if="userType === 1" class="hidden-sm-and-down">
                <v-container>
                    <v-row align="center">
                         <v-col class="subtitle-1 justify-center">
                            {{ userName }}
                        </v-col> 
                    </v-row>
                </v-container>
            </v-toolbar-title>

            <v-spacer class="hidden-sm-and-down"></v-spacer>

            <v-spacer></v-spacer>
            
            <v-toolbar-items class="hidden-sm-and-down">
                <!-- Administradores: -->
                <v-menu v-if="(userType === 1)" offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn text class="text-none light-blue--text text--darken-4" v-on="on">
                            <v-icon large>mdi-cog</v-icon>&nbsp;Configuración</v-btn>
                    </template>
                    <v-list color="grey lighten-5">
                        <v-list-item v-if="(userType === 1)" @click="onEspecies">
                            <v-list-item-title class="light-blue--text text--darken-4">
                                <v-icon color="light-blue darken-4">mdi-dog-side</v-icon>&nbsp; Catálogo de especies
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item v-if="(userType === 1)" @click="onVeterinarias">
                            <v-list-item-title class="light-blue--text text--darken-4">
                                <v-icon color="light-blue darken-4">mdi-hospital-building</v-icon>&nbsp; Clínicas veterinarias
                            </v-list-item-title>
                        </v-list-item>

                        <!-- <v-list-item v-if="(userType === 1)" @click="onGoogleMapsTest1">
                            <v-list-item-title class="light-blue--text text--darken-4">
                                <v-icon color="light-blue darken-4">mdi-hospital-building</v-icon>&nbsp; Prueba Google Maps 1
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item v-if="(userType === 1)" @click="onCloseBuy">
                            <v-list-item-title class="light-blue--text text--darken-4">
                                <v-icon color="light-blue darken-4">mdi-hospital-building</v-icon>&nbsp; Prueba Google Maps 2
                            </v-list-item-title>
                        </v-list-item> -->

                        <v-divider></v-divider>

                        <v-list-item v-if="(userType === 1)" @click="onAdministradores">
                            <v-list-item-title class="light-blue--text text--darken-4">
                                <v-icon color="light-blue darken-4">mdi-account-key</v-icon>&nbsp; Administradores
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>                      
                </v-menu>

                <v-btn
                    v-if="userType === 1"
                    text
                    class="text-none light-blue--text text--darken-4" 
                    @click="onMascotas">
                    <v-icon>mdi-dog</v-icon>&nbsp;Mascotas
                </v-btn>

                <v-menu v-if="(userType === 1)" offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn text class="text-none light-blue--text text--darken-4" v-on="on">
                            <v-icon large>mdi-advertisements</v-icon>&nbsp;Publicidad</v-btn>
                    </template>
                    <v-list color="grey lighten-5">
                        <v-list-item v-if="(userType === 1)" @click="onClientesPublicidad">
                            <v-list-item-title class="light-blue--text text--darken-4">
                                <v-icon color="light-blue darken-4">mdi-domain</v-icon>&nbsp; Clientes de Publicidad
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item v-if="(userType === 1)" @click="onPublicidad">
                            <v-list-item-title class="light-blue--text text--darken-4">
                                <v-icon color="light-blue darken-4">mdi-calendar-month</v-icon>&nbsp; Campañas de Publicidad
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>                
                </v-menu>
                
                <!-- Todos: -->
                <v-btn
                    text
                    class="text-none light-blue--text text--darken-4" 
                    @click="onLogout">
                    <v-icon>mdi-exit-to-app</v-icon>&nbsp;Salir</v-btn
                >
            </v-toolbar-items>
            <!-- Fin del menú visible si se inició sesión -->
        </v-app-bar>
    </span>
</template>

<script>
import { mapGetters } from 'vuex';
import LocaleChanger from '@/components/LocaleChanger';

export default {
    name: 'AppNavigation',
    data() {
        return {
            drawer: false,
            overlay: false,
            //valid: false
            //     e1: true,
            //     password: '',
            //     passwordRules: [v => !!v || 'Introduzca la contraseña'],
            //     email: '',
            //     emailRules: [
            //         v => !!v || 'Introduzca su correo electrónico',
            //         v =>
            //             /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
            //             'Introduzca un correo válido'
            //     ],
        };
    },
    components: {
        LocaleChanger,
    },
    methods: {
        onHome() {
            if (!this.isAuthenticated) {
                this.drawer = false;
            }
        },
        
        onAdministradores() {
            this.$router.push('/administradores');
            this.drawer = false;
        },
        onMascotas() {
            this.$router.push('/pets');
            this.drawer = false;
        },
        onCloseBuy() {
            this.$router.push('/closebuy');
            this.drawer = false;
        },
        onGoogleMapsTest1() {
            this.$router.push('/veterinariastest');
            this.drawer = false;
        },
        onEspecies(){
            this.$router.push('/especies');
            this.drawer = false;
        },
        onVeterinarias() {
            this.$router.push('/veterinarias');
            this.drawer = false;
        },

        onClientesPublicidad() {
            this.$router.push('/clientes');
            this.drawer = false;
        },

        onPublicidad() {
            this.$router.push('/publicidad');
            this.drawer = false;
        },

        onLogout() {
            //console.log('logout');
            //this.overlay = true;
            this.$store.dispatch('logout');
            this.drawer = false;
        },
        
    },
    computed: {
        ...mapGetters([
            'appTitle',
            'logo1',
            'isAuthenticated',
            'userType',
            'userName',
        ]),
    },
};
</script>

<style scoped>
h5 {
    /* color: 'teal darken-1'; */
    color: #00897b;
}

.logo-hover:hover {
    cursor: pointer;
}

</style>
